/* eslint @typescript-eslint/no-var-requires: 0 */
import { ILanguageResource } from './types'

import en from './resources/en.json'
import da from './resources/da.json'
import sv from './resources/sv.json'
import no from './resources/no.json'

// Import dayjs locales
import 'dayjs/locale/en'
import 'dayjs/locale/da'
import 'dayjs/locale/sv'
import 'dayjs/locale/nb'

function makeResource(translation: ILanguageResource['translation']): ILanguageResource {
	return { translation }
}

export default {
	en: makeResource(en),
	da: makeResource(da),
	sv: makeResource(sv),
	no: makeResource(no),
}
